import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Group } from '../models/Group'

interface NavigationState {
	backNavigation:number
	currentSelectedGroup: Group|undefined,	
}

const initialState: NavigationState = {
	backNavigation: -1,
	currentSelectedGroup: undefined,
}

export const navigationSlice = createSlice({
  name: 'token',
  initialState: initialState,
  reducers: {
    incrementBackNavigation:(state) => {
		state.backNavigation -= 1
	},
	
	decrementBackNavigation:(state) => {
		state.backNavigation += 1
		if (state.backNavigation > 0) {
			state.backNavigation = -1
		}
	},

	clearBackNavigation:(state) => {
		state.backNavigation = -1
	},

	setSelectedGroup:(state, action: PayloadAction<Group>) => {
		state.currentSelectedGroup = action.payload
	},

	clearSelectedGroup:(state) => {
		state.currentSelectedGroup = undefined
	}

  },
})

// Action creators are generated for each case reducer function
export const { 
	incrementBackNavigation, 
	clearBackNavigation,
	decrementBackNavigation, 
	setSelectedGroup, 
	clearSelectedGroup } = navigationSlice.actions

export default navigationSlice.reducer